import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import scrollTop from '../components/scrollTop';
import './Skill.css';
import APIEndPoints from '../middleware/APIEndPoints';

const Skills = () => {
  const [skills, setSkills] = useState([]);

  const getSkillUrl = APIEndPoints.skills.url;

  // Fetch skills from backend on component mount
  useEffect(() => {
    const fetchSkills = async () => {
      try {
        const res = await axios.get(getSkillUrl);
        setSkills(res.data); // Assuming res.data contains the array of skills
      } catch (error) {
        console.error('Error fetching skills:', error);
      }
    };

    scrollTop(); 
    fetchSkills(); 
  }, []);

  return (
    <div className="mt-4 pt-4">
      {/* Header Section with motion.div directly applying animation */}
      <motion.div
        initial={{ opacity: 0, y: -80 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: [0.25, 0.25, 0.25, 0.75] }}
        className="text-center mb-12 space-y-4"
      >
        <h4 className="text-3xl lg:text-[3rem] uppercase text-accent font-medium mb-2 tracking-wide">My Skills</h4>
        <h2 className="text-4xl lg:text-[4rem] font-bold mb-6">Technologies I Excel In</h2>
        <p className="text-lg text-gray-400">Here are some of the technologies and skills I have acquired over time.</p>
      </motion.div>

      {/* Skills Container Section with motion.div directly applying animation */}
      <div className="skillcontainer mx-auto px-2 pl-2 sm:pl-[14rem] md:pl-4">
        <motion.div
          initial={{ opacity: 0, y: 80 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.1, ease: [0.25, 0.25, 0.25, 0.75] }}
          className="flex flex-wrap justify-around"
        >
          {skills.map((skill, index) => (
            <motion.div
              key={skill._id} 
              className="relative w-full md:w-1/2 lg:w-1/3 mb-8"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1, ease: [0.25, 0.25, 0.25, 0.75] }}
            >
              <div className="card relative">
                <div className="face face1">
                  <motion.div
                    className="content flex justify-center items-center space-x-5 font-bold text-2xl"
                    animate={{ rotate: 360 }}
                    transition={{ duration: 1.5, loop: Infinity, ease: "linear" }}
                  >
                    <img src={skill.image} alt={skill.title} className="w-10 h-10 rounded-full" />
                    <h3 className="uppercase">{skill.title}</h3>
                  </motion.div>
                </div>
                <div className="face face2 relative">
                  <div className="content w-full h-full space-y-4 text-black">
                    {skill.description}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default Skills;
